// extracted by mini-css-extract-plugin
export var bodySections = "_80-8";
export var gray = "_80-7";
export var green = "_80-4";
export var iconContainer = "_80-9";
export var iconWidgetContainer = "_80-1";
export var phoneIcon = "_80-2";
export var red = "_80-5";
export var statusDot = "_80-3";
export var widgetContainer = "_80-0";
export var yellow = "_80-6";